// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-e0095b62]{background-color:#f5f5f5;border-radius:8px;padding:16px}.v-divider[data-v-e0095b62]{margin:16px 0}.v-list-item[data-v-e0095b62]{padding:0}.v-list-item-content[data-v-e0095b62]{margin-left:0}.v-btn[data-v-e0095b62]{text-transform:none}", ""]);
// Exports
module.exports = exports;
